import React from 'react';

import {Content} from './Content';

export function Home() {
  return <Content />;
}
